import { Breadcrumb, Container } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";

const CadastroInicialView = () => {
  const { pathname } = useLocation();

  const steps = [
    { label: "1. Empresa", path: "/cadastro-inicial/empresa" },
    { label: "2. Usuário", path: "/cadastro-inicial/usuario" },
  ];

  const currentIndex = steps.findIndex((s) => pathname.startsWith(s.path));

  return (
    <Container className="mt-3">
      <div className="mb-4">
        <h3 className="fw-bold text-primary mb-1">Cadastro Inicial</h3>
        <p className="text-muted mb-3">
          Complete o cadastro da sua empresa e do seu usuário para ativar o acesso ao sistema.
        </p>
        <Breadcrumb className="bg-body-tertiary border p-2 rounded">
          {steps.map((step, index) => {
            const isComplete = index < currentIndex;
            const isActive = index === currentIndex;

            return (
              <Breadcrumb.Item
                key={step.path}
                active={isActive}
                className={
                  isComplete
                    ? "text-success fw-semibold"
                    : isActive
                    ? "fw-bold"
                    : "text-muted"
                }
              >
                {step.label}
              </Breadcrumb.Item>
            );
          })}
        </Breadcrumb>
      </div>
      <Outlet />
    </Container>
  );
};

export default CadastroInicialView;
